module.exports = __webpack_public_path__ + "static/Crash-Management-Logo-95b5bd96231cadadc580f1febc701b75.png";